import React from 'react';
import { Section } from './Section';
import { SectionCta } from './SectionCta';
import { volumes } from '../data/content';
const flow = ['Plan better', 'Control movement', 'Catch problems early', 'Rescue when possible', 'Finish with confidence'];
export function Volumes() {
  return <Section eyebrow="What's inside" title="Inside the Anti-Refinement System™" alt data-id="element-242" data-mp="1c4yy3391wfsk">
      <div className="space-y-4" data-id="element-243" data-mp="1zvb3o7gtq0fz">
        {volumes.map(vol => <article key={vol.number} className="rounded-3xl border border-white/10 bg-ink-800 p-5 sm:p-6" data-id="element-244" data-mp="1zsylbt75lo2e">
            <span className="inline-block rounded-full bg-lime px-3 py-1 text-[11px] font-black uppercase tracking-wider text-black" data-id="element-245" data-mp="1quwg11ge099b">
              📘 {vol.number}
            </span>
            <h3 className="mt-3 font-display text-lg leading-tight text-white sm:text-2xl" data-id="element-246" data-mp="ffhinwk9nfdo">
              {vol.title}
            </h3>
            <p className="mt-2 text-sm font-semibold leading-snug text-lime sm:text-base" data-id="element-247" data-mp="kfc77tgkjsvk">
              {vol.lead}
            </p>
            <p className="mt-2 text-sm leading-relaxed text-white/65" data-id="element-248" data-mp="3oa9aurpxjdb7">{vol.body}</p>
          </article>)}
      </div>

      <div className="mt-10 rounded-3xl border border-lime/25 bg-lime/[0.05] p-5 text-center sm:p-6" data-id="element-249" data-mp="20ynnso0gjlj">
        <h3 className="font-display text-lg text-white sm:text-2xl" data-id="element-250" data-mp="3t7j8uvrdwxan">And that’s just the core system…</h3>
        <p className="mx-auto mt-2 max-w-xl text-sm text-white/65" data-id="element-251" data-mp="b1dawxkjc8ro">
          The Anti-Refinement System™ becomes your practical reference throughout the entire aligner
          workflow:
        </p>
        <ol className="mt-5 grid gap-2 sm:grid-cols-5" data-id="element-252" data-mp="kr6i7mdna1q4">
          {flow.map((step, i) => <li key={step} className="rounded-2xl border border-white/10 bg-black/40 px-3 py-3 text-xs font-bold uppercase leading-snug tracking-wide text-white/85" data-id="element-253" data-mp="fsmy7rim300e" data-mpi={i}>
              <span className="mr-1 text-lime" data-id="element-254" data-mp="pr2pbuhn299w">{i + 1}.</span>
              {step}
            </li>)}
        </ol>
      </div>

      <SectionCta headline="6 volumes. One structured path from planning to finishing." data-id="element-255" data-mp="wv2a780q4sul" />
    </Section>;
}